import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SnackbarProvider } from 'notistack';
import Router from './Router';
import { UserProvider } from '../context/UserContext';
import runConfig from '../config';

const config = runConfig();
const queryClient = new QueryClient();

export default function App() {
  return (
    <div style={{ backgroundColor: '#f2fffd' }}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ThemeProvider theme={config.mui.theme}>
            <SnackbarProvider>
              <UserProvider>
                <Router />
              </UserProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </LocalizationProvider>
      </QueryClientProvider>
    </div>
  );
}
